import React, { useContext, useState, useEffect, MouseEventHandler } from 'react';
import { UserContext } from '../UserContext';
import { PageContext } from '../PageContext';
import { Col, Container, Row } from 'reactstrap';
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridCellProps, GridDataStateChangeEvent, GridPageChangeEvent,getSelectedState,GridSelectionChangeEvent} from '@progress/kendo-react-grid';
import { Input,Checkbox, CheckboxChangeEvent, InputChangeEvent, Switch, SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { DatCatSizeDataItem, upDatCatSizeDataItem, SiteEntry, PubListEntry } from '../../services/interfaces';
import { getDeadlineList } from '../../services/apiAdminService';
import { process, State, DataResult, GroupDescriptor } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Label } from '@progress/kendo-react-labels';
import { data } from 'react-router-dom';
import { ConfirmDialog } from '../ConfirmDialog';
import { PubList, SiteList, StatusList } from '../FormComponents';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

interface PageState {
    skip: number;
    take: number;
}

const initialPageState: PageState = { skip: 0, take: 20 };

const initialDataState: State = {
    sort: [{ field: 'category', dir: 'asc' }],
};

interface editProps{
    size:DatCatSizeDataItem,
    title: string,
    onClose: () => void;
    action:string
}




const EditDialog=(props:editProps)=>{

    // const [newSize, setNewSize]= useState<NewSize>(
    //     {
    //         category:"",
    //         columnWidth:0,
    //         gutter:0,
    //         depthConversion:0,
    //         modYNB:"",
    //         EPSPathNum:0,
    //         tempChar:"",
    //         tempInt:0,
    //         siteCode:"",
    //     }
    // );
    const [dlgTitle, setDlgTitle]=useState<string>("");
    const [selectedSize,setSelectedSize]=useState([]);
    const [showDelConfirm, setShowDelConfirm]=useState(false);
    const [showDeleteButton, setShowDeleteButton]=useState(true);
    const [intAction,setIntAction]=useState("");
    const [siteValid, setSiteValid]=useState(false);
    const [pubValid, setPubValid]=useState({
        pubNum:false,
        pubName:false,
        pubSite:false
    });
    // const setSiteCode=(e: SiteEntry[])=>{
    //     setNewSize({...newSize, siteCode: (e[0].code) || ''})        
    // }

    // const setCategory=(e: InputChangeEvent)=>{
    //     setNewSize({...newSize, category: (e.value)})
    // }

    // const setColWidth=(e: InputChangeEvent)=>{
    //     setNewSize({...newSize, columnWidth: Number(e.value)})
    // }

    // const setGutter=(e: InputChangeEvent)=>{
    //     setNewSize({...newSize, gutter: Number(e.value)})
    // }

    // const setDepthConv=(e: InputChangeEvent)=>{
    //     setNewSize({...newSize, depthConversion: Number(e.value)})
    // }
    


    // const validateSize= async()=>{
    //     var statusValid={
    //         site:false,
    //         category:false,
    //     }
    //     if (newSize.category!=""){
    //         statusValid.category=true;
    //     }
    //     if (newSize.siteCode!==""){
    //         statusValid.site=true;
    //         setSiteValid(true);            
    //     }
    //     return statusValid;
    // }
    

    const viewDeleteButton=()=>{
        setShowDeleteButton(true);
    }

    const hideDeleteButton=()=>{
        setShowDeleteButton(false);
    }


    const viewDelConfirm=()=>{
        setShowDelConfirm(true);
    }

    const hideDelConfirm=()=>{
        setShowDelConfirm(false);
    }



    // const deleteThisSize=()=>{
    //     if (props.action=="Edit"){
    //         const category = newSize.category;
    //         const site = newSize.siteCode;
    //         if (site!="" && category!=""){
    //            deleteDatCatSize(category,site);
    //         }
    //     }        
    //     hideDelConfirm();
    //     props.onClose();
    // }



    // const saveThisSize= async ()=>{

    //     var oCategory;
    //     var oModYNB;
    //     var ositeCode;
    //     console.log(newSize);
    //     validateSize().then((sizeValid)=>{
    //          if (sizeValid.category===true && sizeValid.site===true){
    //              if (intAction==="Edit"){
    //                 //edit existing pub
    //                 oCategory=props.size.category;
    //                 oModYNB=props.size.modYNB;
    //                 ositeCode=props.size.siteCode;
    //              }else{
    //                  //create new pub
    //                 oCategory="";
    //                 oModYNB="";
    //                 ositeCode="";
    //              }
    //              var formData:upDatCatSizeDataItem = {
    //                 oCategory: oCategory,
    //                 oModYNB:oModYNB,
    //                 ositeCode:ositeCode,
    //                 siteCode: newSize.siteCode,
    //                 category: newSize.category,
    //                 columnWidth: newSize.columnWidth,
    //                 gutter: newSize.gutter,
    //                 depthConversion: newSize.depthConversion,
    //                 modYNB:newSize.modYNB,
    //                 EPSPathNum:newSize.EPSPathNum,
    //                 tempChar:newSize.tempChar,
    //                 tempInt: newSize.tempInt
    //               };
    //              console.log(formData);
    //              saveDatCatSize(formData).then((data)=>{
    //                  console.log(data);
    //                  props.onClose();
    //              });    
    //          }else{
    //              console.log("Missing fields");
    //          }    
    //     });
        
    // }

    // useEffect(()=>{
    //     console.log(newSize);
    // },[newSize])

    // useEffect(() => {  
    //     setDlgTitle(props.title);
    //     console.log(props.size); 
    //     if (props.size){
    //         setNewSize({
    //             category:props.size.category,
    //             columnWidth:props.size.columnWidth,
    //             gutter:props.size.gutter,
    //             depthConversion:props.size.depthConversion,
    //             modYNB:props.size.modYNB,
    //             EPSPathNum:props.size.EPSPathNum,
    //             tempChar:props.size.tempChar,
    //             tempInt:props.size.tempInt,
    //             siteCode:props.size.siteCode, 
    //         });            
    //     }
    //     setIntAction(props.action);
    //     if (props.action==="Edit"){
    //         viewDeleteButton();
    //     }else{
    //         hideDeleteButton();
    //     }
    // },[]);
    // return(
    //     <>
    //     <Dialog title={dlgTitle} onClose={props.onClose} width={700} height={"45vh"}>
    //         {showDelConfirm?<ConfirmDialog title='Delete Sub-status Entry' message='This will permanently delete the selected sub-status entry. This can not be undone. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDelConfirm} onConfirm={deleteThisSize}  ></ConfirmDialog>:null}

    //         <Row className='mb-3'>
    //             <Col xs="3"><Label className='mb-2'>Site:</Label></Col>
    //             <Col xs="9"><SiteList value={newSize.siteCode} setReturnAction={setSiteCode} multi={false} valid={siteValid} className="" ></SiteList></Col>
    //         </Row>
    //         <Row className='mb-3'>
    //             <Col xs="3"><Label className='mb-2'>Ad Type:</Label></Col>
    //             <Col xs="9"><Input value={newSize.category} onChange={setCategory} required={true}></Input></Col>
    //         </Row>
    //         <Row className='mb-3'>
    //             <Col xs="3"><Label className='mb-2'>Column Width:</Label></Col>
    //             <Col xs="9"><Input value={newSize.columnWidth} onChange={setColWidth}></Input></Col>
    //         </Row>
    //         <Row className='mb-3'>
    //             <Col xs="3"><Label className='mb-2'>Gutter:</Label></Col>
    //             <Col xs="9"><Input value={newSize.gutter} onChange={setGutter}></Input></Col>
    //         </Row>
    //         <Row className='mb-3'>
    //             <Col xs="3"><Label className='mb-2'>Depth Conversion:</Label></Col>
    //             <Col xs="9"><Input value={newSize.depthConversion} onChange={setDepthConv}></Input></Col>
    //         </Row>
    //         <DialogActionsBar>
    //             <Button themeColor={"secondary"}onClick={props.onClose}>Cancel</Button>
    //             <Button themeColor={"primary"} onClick={saveThisSize}>Save</Button>
    //             {showDeleteButton?<Button themeColor={"warning"} onClick={viewDelConfirm}>Delete</Button>:null}
    //         </DialogActionsBar>
    //     </Dialog>
    //     </>
    // )
}

export default function AdminDeadline (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    const user = userContext?.user;
    const [deadlines, setDeadlines] = useState([]);
    const [siteSelected, setSiteSelected]=useState<SiteEntry>(
        {
            code:"",
            name:"",
            logo_Prefix:"",
            primary_ip:"",
            backup_ip:"",
            temp_Char:"",
            temp_Int:"",
            vol1_Unc_Path:"",
            vol2_Unc_Path:""
        }

    );
    const [pubSelected, setPubSelected]=useState<string[]>([]);
    const [siteFilter,setSiteFilter]=useState("");
    const [showEditDialog,setShowEditDialog]=useState(false);
    const [title,setTitle]=useState("");
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(deadlines,dataState));
    const [page, setPage] = React.useState<PageState>(initialPageState);
    const [action,setAction]=useState("Edit");
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const idGetter = getter('pubNum');

    const selectSite=(site:SiteEntry[])=>{
       
        setSiteSelected(site[0] || {
            code:"",
            name:"",
            logo_Prefix:"",
            primary_ip:"",
            backup_ip:"",
            temp_Char:"",
            temp_Int:"",
            vol1_Unc_Path:"",
            vol2_Unc_Path:""
        });
    }

     const selectPub=(pub:string[])=>{
  
        setPubSelected(pub);
    }
    
    // const hideEditDialog=()=>{
    //     setShowEditDialog(false);
    //     getDeadlineList();
    // }

    // const newEditDialog=(e: React.MouseEvent<HTMLButtonElement>)=>{
    //     setAction("New");
    //     setTitle("New Size");
    //     setSizeSelected( {
    //         category:"",
    //         columnWidth:0,
    //         gutter:0,
    //         depthConversion:0,
    //         modYNB:"",
    //         EPSPathNum:0,
    //         tempChar:"",
    //         tempInt:0,
    //         siteCode:"",
    //     })
    //     setShowEditDialog(true);
    // }



    const getDeadlines=()=>{
        if (pubSelected.length>0){
            getDeadlineList(pubSelected.join(",")).then(data=>{
                setDeadlines(data);
                //setDataResult(process(data, dataState));
            })
        }
    }

    const onDataStateChange = (e: GridDataStateChangeEvent) => {
        setDataState(e.dataState);
        //setDataResult(process(sizes, e.dataState));
    };
    const pageChange = (event: GridPageChangeEvent) => {
        const targetEvent = event.targetEvent as PagerTargetEvent;        
        setPage({
            ...event.page,
            take:20
        });
    }

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        console.log(event.startDataItem);

        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "UID"
        });
        console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
    };

    // useEffect(()=>{
    //     console.log(siteSelected);
    //     if (siteSelected){
    //         setTitle("Size Configuration for: " + siteSelected);
    //         setShowEditDialog(true);
    //     }
    // },[siteSelected])
   
    useEffect(()=>{
        console.log(pubSelected);
    },[pubSelected]);

    useEffect(()=>{
         if (siteSelected.code!=""){
            setSiteFilter(siteSelected.code);
        }
    },[siteSelected])

    useEffect(() => {   
        if (user?.loggedIn){
            //getDeadlines();
        }else{
            window.location.replace("/Login");
        }
    }, []);


    const initialGroup: GroupDescriptor[] = [
        {
            field: 'pubName'
        }
    ];

    const formatCell = (props: GridCellProps) => {
        // Example: customize as needed, here just renders the value
        var cellData = props.dataItem["setting"] as string;
        var trimData="";
        if (cellData){
            trimData = cellData.trim();
        }
        var retVal = "";
        switch (trimData){
            case "EORDER":
                retVal="BOOKED";
                break;
            case "PROOFOUT":
                retVal="PROOF OUT";
                break;
            default:
                retVal=cellData;
                break; 
        }
        return (
            <td colSpan={1} className='k-table-td' role='gridcell' aria-colindex={3} aria-selected="false" data-grid-col-index="2">
                {retVal}
            </td>
        );
    }

    return (
        <>
        {user?.loggedIn && user.type==5 ?
        <Container fluid>
            <h2>Deadline Management</h2>
            <Toolbar>
                <SiteList setReturnAction={selectSite} value={siteSelected} multi={false} className='toolbarField' valid={true}></SiteList>
                <PubList setReturnAction={selectPub} value={pubSelected} archiveOnly={false} liveOnly={true} type="multi" siteFilter={siteFilter} className='toolbarField' returnField='name' onlineOnly={false} printOnly={false}></PubList>
                <Button title="Get Deadliines" themeColor={'primary'} type="button" onClick={getDeadlines}>
                    Get Deadlines
                </Button>     
                <Button title="Set Deadliines" themeColor={'primary'} type="button">
                    Set Deadlines
                </Button>     
            </Toolbar>
            <Grid
                // data={(dataResult.data.slice(page.skip, page.take + page.skip))?.map((item)=>({
                //     ...item, 'selected':selectedState[idGetter(item)]
                // }))}
                dataItemKey='UID'
                id="deadlineGrid"
                className='adminGrid'
                sortable={false}
                selectable={{ enabled:true, mode: 'single' }}
                data={deadlines}
                autoProcessData={true}
                //groupable={true}
                defaultGroup={initialGroup}
                resizable={true}                // pageable={{
                //     buttonCount: 4,
                //     info:true,                
                //     pageSizeValue: 20
                // }}
                //{...dataState}
                //onDataStateChange={onDataStateChange}
                //onPageChange={pageChange}
                onSelectionChange={onSelectionChange}
                //skip={page.skip}
                //take={page.take}
                //total={dataResult.total}
                //reorderable={true}
                //filterable={true}
            >
                <GridColumn field='pubName' title='Publication'/>
                <GridColumn field='setting' title='Type'/>
                <GridColumn title='Monday' children={[
                    <GridColumn field='monDays' title='Days' key="monDays" width={75} />,
                    <GridColumn field='monTime' title='Time' key="monTime" width={100}/>
                ]} />
                <GridColumn title='Tuesday' children={[
                    <GridColumn field='tueDays' title='Days' key="tueDays" width={75}/>,
                    <GridColumn field='tueTime' title='Time' key="tueTime" width={100}/>
                ]} />
                <GridColumn title='Wednesday' children={[
                    <GridColumn field='wedDays' title='Days' key="wedDays" width={75}/>,
                    <GridColumn field='wedTime' title='Time' key="wedTime" width={100}/>
                ]} />
                <GridColumn title='Thursday' children={[
                    <GridColumn field='thuDays' title='Days' key="thuDays" width={75}/>,
                    <GridColumn field='thuTime' title='Time' key="thuTime" width={100}/>
                ]} />
                <GridColumn title='Friday' children={[
                    <GridColumn field='friDays' title='Days' key="friDays" width={75}/>,
                    <GridColumn field='friTime' title='Time' key="friTime" width={100}/>
                ]} />
                <GridColumn title='Saturday' children={[
                    <GridColumn field='satDays' title='Days' key="satDays" width={75}/>,
                    <GridColumn field='satTime' title='Time' key="satTime"width={100} />
                ]} />
                <GridColumn title='Sunday' children={[
                    <GridColumn field='sunDays' title='Days' key="sunDays" width={75}/>,
                    <GridColumn field='sunTime' title='Time' key="sunTime" width={100}/>
                ]} />
            </Grid>
            {showEditDialog?
                <p></p>// <EditDialog title={title} size={sizeSelected as DatCatSizeDataItem} onClose={hideEditDialog} action={action}></EditDialog>
            :null
            }
        </Container>
        : <></>}
        </>
    );
}